import { fetchJson } from "../lib/api";

export type AngebotSort = "recent_desc" | "amount_desc";

export type AngebotRow = {
  angebot_id: string;
  doc_number: string | null;
  doc_date: string | null;
  supplier: string | null;
  currency: string | null;
  page_count: number | string | null;
  line_count: number | string | null;
  priced_line_count: number | string | null;
  positions_total: number | string | null;
  pdf_available: boolean;
};

export type AngebotMatchStatus = "matched" | "unresolved";

export type AngebotLine = {
  line_pos: string;
  page_no: string | number | null;
  article_code: string | null;
  alt_article_code: string | null;
  manufacturer_article_code: string | null;
  description: string | null;
  qty: string | number | null;
  uom: string | null;
  list_unit_price: string | number | null;
  discount_pct: string | number | null;
  net_unit_price: string | number | null;
  line_net_amount: string | number | null;
  article_group_key: string | null;
  match_status: AngebotMatchStatus;
  article_detail_available: boolean;
};

export type AngeboteListResponse = {
  total: number;
  limit: number;
  offset: number;
  sort: AngebotSort;
  items: AngebotRow[];
};

export type AngebotDetailResponse = {
  angebot: AngebotRow;
  line_total: number;
  lines: AngebotLine[];
};

export async function fetchAngebote(params: {
  q?: string;
  supplier?: string;
  sort?: AngebotSort;
  limit?: number;
  offset?: number;
}): Promise<AngeboteListResponse> {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.supplier) search.set("supplier", params.supplier);
  if (params.sort) search.set("sort", params.sort);
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  if (params.offset !== undefined) search.set("offset", String(params.offset));
  const query = search.toString();
  return fetchJson<AngeboteListResponse>(
    `/api/angebote${query ? `?${query}` : ""}`,
  );
}

export async function fetchAngebotDetail(
  angebotId: string,
): Promise<AngebotDetailResponse> {
  return fetchJson<AngebotDetailResponse>(
    `/api/angebote/${encodeURIComponent(angebotId)}`,
  );
}
